import { activitiesConstants } from "@data/constants/activitiesConstants"
import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"

const initialState = {
    byActivityId: {},
}

export default function pendingAttachments(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        case activitiesConstants.ADD_PENDING_ATTACHMENT: {
            const { activityId, stepIndex, tmpKey } = action.payload ?? {}
            if (!activityId || !stepIndex || !tmpKey) return state
            const existingForActivity = state.byActivityId[activityId] ?? {}
            const existingForStep = existingForActivity[stepIndex] ?? []
            if (existingForStep.includes(tmpKey)) return state
            return {
                ...state,
                byActivityId: {
                    ...state.byActivityId,
                    [activityId]: {
                        ...existingForActivity,
                        [stepIndex]: [...existingForStep, tmpKey],
                    },
                },
            }
        }

        case activitiesConstants.CLEAR_PENDING_ATTACHMENTS: {
            const { activityId } = action.payload ?? {}
            if (!activityId || !state.byActivityId[activityId]) return state
            const next = { ...state.byActivityId }
            delete next[activityId]
            return { ...state, byActivityId: next }
        }

        default:
            return state
    }
}
